module.exports = __webpack_public_path__ + "img/style-empty-placeholder-zh.8e8792ff.png";